<template>
  <div class="home">
    <div class="flex show jsb">
      <div class="img flex jsc alc">
        <!-- <viewer :images="detail.imageUrl && detail.imageUrl.split('&')"> -->

        <!-- </viewer> -->

        <swiper :options="swiperOption">
          <swiper-slide v-for="item in detail.imageUrl.split('&')" :key="item">
            <img :src="item" />
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>

    <el-form ref="form" :model="detail" class="form" style="display: flex; flex-wrap: wrap">
      <!-- 图片独有信息 -->

      <div class="title">
        <!-- <span>生物分类信息</span> -->
        <span>{{ $t('details.taxonomy') }}</span>
      </div>

      <div class="p10">
        <el-form-item :label="$t('details.Broadcategory') + ':'" prop="trivialName">
          <span v-html="detail.trivialName" dd="请输入大类" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.trivialNameEn" dd="请输入大类" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.phylum') + ':'" prop="phylum">
          <span v-html="detail.phylum" dd="请输入门" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.phylumEn" dd="请输入门-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.classA') + ':'" prop="classA">
          <span v-html="detail.classA" dd="请输入纲" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.classEn" dd="请输入纲-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.subclass') + ':'" prop="subclass">
          <span v-html="detail.subclass" dd="请输入亚纲" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.subclassEn" dd="请输入亚纲-英文" v-else></span>
        </el-form-item>
        <!-- <el-form-item label="亚纲-英文" prop="subclassEn"> </el-form-item> -->
        <el-form-item :label="$t('details.infraclass') + ':'" prop="infraclass">
          <span v-html="detail.infraclass" dd="请输入次纲" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.infraclassEn" dd="请输入次纲-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.superorder') + ':'" prop="superorder">
          <span v-html="detail.superorder" dd="请输入超目" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.superorderEn" dd="请输入次纲-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.orderA') + ':'" prop="orderA">
          <span v-html="detail.orderA" dd="请输入目" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.orderEn" dd="请输入目-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.suborder') + ':'" prop="suborder">
          <span v-html="detail.suborder" dd="请输入亚目" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.suborderEn" dd="请输入亚目-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.infraorder') + ':'" prop="infraorder">
          <span v-html="detail.infraorder" dd="请输入次目" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.infraorderEn" dd="请输入次目-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.superfamily') + ':'" prop="superfamily">
          <span v-html="detail.superfamily" dd="请输入超科" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.superfamilyEn" dd="请输入超科-英文"></span>
        </el-form-item>

        <el-form-item :label="$t('details.family') + ':'" prop="family">
          <span v-html="detail.family" dd="请输入科" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.familyEn" dd="请输入科-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.subfamily') + ':'" prop="subfamily">
          <span v-html="detail.subfamily" dd="请输入亚科" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.subfamilyEn" dd="请输入亚科-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.genus') + ':'" prop="genus">
          <span v-html="detail.genus" dd="请输入属" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.genusEn" dd="请输入属-英文" v-else></span>
        </el-form-item>
        <el-form-item :label="$t('details.species') + ':'" prop="genus" v-if="$i18n.locale != 'en-us'">
          <span v-html="detail.species" dd="请输入种名"></span>
        </el-form-item>
        <el-form-item v-else :label="$t('details.species') + ':'" prop="species"
          style="width: 100%; font-style: italic; font-weight: 600">
          <span v-html="detail.speciesEn" dd="请输入种名-英文"></span>
        </el-form-item>

        <el-form-item :label="$t('details.nomenclator') + ':'" prop="nomenclatorEn">
          <span v-html="detail.nomenclatorEn" dd="请输入命名人-英文" v-if="$i18n.locale != 'en-us'"></span>
        </el-form-item>
        <el-form-item :label="$t('details.defineTime') + ':'" prop="defineTime">
          <span v-html="detail.defineTime" dd="确定时间"></span>
        </el-form-item>
        <el-form-item :label="$t('details.revisedSpecies') + ':'" prop="revisedSpecies">
          <span v-html="detail.revisedSpecies" dd="请输入修订属种" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.revisedSpeciesEn" dd="请输入修订属种-英文" v-else></span>
        </el-form-item>

        <div style="width: 220px"></div>
        <div style="width: 220px"></div>
      </div>

      <div class="title">
        <!-- <span>化石标本信息</span> -->
        <span>{{ $t('details.specimen') }}</span>
      </div>
      <div class="p10">
        <el-form-item :label="$t('details.reference') + ':'" prop="reference">
          <span v-html="detail.reference" dd="请输入发表文献" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.referenceEn" dd="请输入发表文献-英文" v-else></span>
        </el-form-item>
        <el-form-item :label="$t('details.doi') + ':'" prop="doi">
          <span v-html="detail.doi" dd="请输入文献DOI"></span>
        </el-form-item>

        <el-form-item :label="$t('details.housedIn') + ':'" prop="housedIn">
          <span v-html="detail.housedIn" dd="请输入馆藏地"></span>
        </el-form-item>
        <el-form-item :label="$t('details.cabinet') + ':'" prop="cabinet">
          <span v-html="detail.cabinet" dd="请输入馆藏柜/厨"></span>
        </el-form-item>

        <el-form-item :label="$t('details.prefix') + ':'" prop="prefix">
          <span v-html="detail.prefix" dd="请输入标本号前缀"></span>
        </el-form-item>
        <el-form-item :label="$t('details.specimentsId') + ':'" prop="specimentsId">
          <span v-html="detail.specimentsId" dd="请输入标本登记号"></span>
        </el-form-item>
        <el-form-item :label="$t('details.fieldNumber') + ':'" prop="fieldNumber">
          <span v-html="detail.fieldNumber" dd="请输入野外编号"></span>
        </el-form-item>
        <el-form-item :label="$t('details.plate') + ':'" prop="plate">
          <span v-html="detail.plate" dd="请输入图版编号"></span>
        </el-form-item>
        <el-form-item :label="$t('details.fig') + ':'" prop="fig">
          <span v-html="detail.fig" dd="请输入图片号"></span>
        </el-form-item>
        <el-form-item :label="$t('details.funding') + ':'" prop="funding">
          <span v-html="detail.funding" dd="请输入资助来源"></span>
        </el-form-item>
        <el-form-item :label="$t('details.typeSpecimen') + ':'" prop="typeSpecimen">
          <span v-html="detail.typeSpecimen" dd="请输入模式情况"></span>
        </el-form-item>
      </div>

      <div class="title">
        <!-- <span>地质信息</span> -->
        <span>{{ $t('details.lithostratigraphy') }}</span>
      </div>

      <div class="p10">
        <el-form-item :label="$t('details.eon') + ':'" prop="eon">
          <span v-html="detail.eon" dd="请输入时代-宙"></span>
        </el-form-item>
        <el-form-item :label="$t('details.era') + ':'" prop="era">
          <span v-html="detail.era" dd="请输入时代-代"></span>
        </el-form-item>
        <el-form-item :label="$t('details.period') + ':'" prop="period">
          <span v-html="detail.period" dd="请输入时代-纪"></span>
        </el-form-item>
        <el-form-item :label="$t('details.epoch') + ':'" prop="epoch">
          <span v-html="detail.epoch" dd="请输入时代-世"></span>
        </el-form-item>
        <el-form-item :label="$t('details.age') + ':'" prop="age" style="width: 40%">
          <span v-html="detail.age" dd="请输入时代-期" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.ageEn" dd="请输入时代-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.ageFrom') + ':'" prop="ageFrom">
          <span v-html="detail.ageFrom" dd="请输入首现年龄/Ma"></span>
        </el-form-item>
        <el-form-item :label="$t('details.ageTo') + ':'" prop="ageTo">
          <span v-html="detail.ageTo" dd="请输入末现年龄/Ma"></span>
        </el-form-item>
        <el-form-item :label="$t('details.ageMid') + ':'" prop="ageMid">
          <span v-html="detail.ageMid" dd="请输入平均年龄/Ma"></span>
        </el-form-item>
        <el-form-item :label="$t('details.section') + ':'" prop="section">
          <span v-html="detail.section" dd="请输入剖面" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.sectionEn" dd="请输入剖面-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.horizon') + ':'" prop="horizon">
          <span v-html="detail.horizon" dd="请输入层位" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.horizonEn" dd="请输入层位-英文" v-else></span>
        </el-form-item>
        <div style="width: 220px"></div>
        <div style="width: 220px"></div>
      </div>

      <div class="title">
        <!-- <span>地理信息</span> -->
        <span>{{ $t('details.geography') }}</span>
      </div>
      <div class="p10">
        <el-form-item :label="$t('details.locality') + ':'" prop="locality">
          <span v-html="detail.locality" dd="请输入产地" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.localityEn" dd="请输入产地-英文"></span>
        </el-form-item>

        <el-form-item :label="$t('details.country') + ':'" prop="country">
          <span v-html="detail.country" dd="请输入国家" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.countryEn" dd="请输入国家-英文"></span>
        </el-form-item>

        <el-form-item :label="$t('details.province') + ':'" prop="province">
          <span v-html="detail.province" dd="请输入省" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.provinceEn" dd="请输入省-英文"></span>
        </el-form-item>

        <el-form-item :label="$t('details.city') + ':'" prop="city">
          <span v-html="detail.city" dd="请输入市" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.cityEn" dd="请输入市-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.county') + ':'" prop="county">
          <span v-html="detail.county" dd="请输入县" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.countyEn" dd="请输入县-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.village') + ':'" prop="village">
          <span v-html="detail.village" dd="请输入村" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.villageEn" dd="请输入村-英文" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.longitude') + ':'" prop="longitude">
          <span v-html="detail.longitude" dd="请输入经度"></span>
        </el-form-item>
        <el-form-item :label="$t('details.latitude') + ':'" prop="latitude">
          <span v-html="detail.latitude" dd="请输入纬度"></span>
        </el-form-item>
        <el-form-item :label="$t('details.attitude') + ':'" prop="attitude">
          <span v-html="detail.attitude" dd="请输入高程"></span>
        </el-form-item>
      </div>

      <div class="title">
        <span>{{ $t('details.otherInfo') }}</span>
      </div>
      <div class="p10">
        <el-form-item :label="$t('details.pictureName') + ':'" prop="pictureName">
          <span v-html="detail.pictureName" dd="请输入图文件名"></span>
        </el-form-item>
        <el-form-item :label="$t('details.provider') + ':'" prop="provider">
          <span v-html="detail.provider" dd="请输入贡献者"></span>
        </el-form-item>
        <el-form-item :label="$t('details.input') + ':'" prop="input">
          <span v-html="detail.input" dd="请输入录入员"></span>
        </el-form-item>
        <el-form-item :label="$t('details.checkA') + ':'" prop="checkA">
          <span v-html="detail.checkA" dd="请输入校对员"></span>
        </el-form-item>
        <el-form-item :label="$t('details.deviceNameAndType') + ':'" prop="pictureName">
          <span v-html="detail.deviceNameAndType" dd="请输入设备名称与型号"></span>
        </el-form-item>
        <el-form-item :label="$t('details.notes') + ':'" prop="notes">
          <span v-html="detail.notes" dd="请输入内容" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.notesEn" dd="请输入内容" v-else></span>
        </el-form-item>

        <el-form-item :label="$t('details.description') + ':'" prop="description">
          <span v-html="detail.description" dd="请输入内容" v-if="$i18n.locale != 'en-us'"></span>
          <span v-html="detail.descriptionEn" dd="请输入描述-英文" v-else></span>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import ImageApi from '@/api/image/index';
import commonApi from '@/api/common/index';

export default {
  data() {
    return {
      infoAct: 0,
      allAct: 0,
      detail: {},
      allList: [],
      form: {},
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  created() { },
  mounted() {
    this.init(this.$route.query.id);

    this.$set(this.$i18n, 'locale', 'en-us');

    localStorage.setItem('language', 'en-us');
  },
  watch: {
    $route(val) {
      if (val.query.id) {
        this.init(this.$route.query.id);
        this.infoAct = 0;
      }
    },
  },
  methods: {
    async init(id) {
      const { data: res } = await ImageApi.getImgInfo(id);
      this.detail = res;
      const { data: res1 } = await commonApi.search({
        searchValue:
          this.detail.trivialName ||
          this.detail.phylum ||
          this.detail.classA ||
          this.detail.subclass ||
          this.detail.infraclass ||
          this.detail.superorder ||
          this.detail.orderA ||
          this.detail.suborder ||
          this.detail.infraorder ||
          this.detail.superfamily ||
          this.detail.family ||
          this.detail.subfamily ||
          this.detail.genus ||
          this.detail.species ||
          '',
        range: 'info',
        pageNum: 1,
        pageSize: 30,
      });
      this.allList = res1.rows;
      this.allAct = this.allList.findIndex((el) => {
        return this.$route.query.id == el.topicId;
      });
    },
    goInfo(item) {
      this.$router.push({
        path: 'imgInfo',
        query: {
          id: item.topicId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 100vw;
  overflow: hidden;
  word-break: break-all;
  word-wrap: break-word;

  .el-form-item {
    margin-bottom: 0 !important;
  }
}

.p10 {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.home {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;

  .title {
    width: 100%;
    font-size: 20px;
    font-weight: 700;
    background: #f8f8f8;
    line-height: 50px;
    padding: 15px;
  }

  .show {
    .img {
      width: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }

    .left-footer {
      width: 80%;
      margin: 20px auto;
    }

    .right {
      width: 25%;
      height: 100%;

      overflow-y: scroll;

      .infoList {
        padding: 20px;
        box-sizing: border-box;
        width: 100%;

        img {
          max-width: 135px;
          max-height: 100%;
          width: auto;
          height: auto;
          flex-shrink: 0;
          margin-bottom: 5px;
        }

        .imgAct {
          border: 2px #1890ff solid;
        }
      }
    }
  }

  .info {
    margin-top: 20px;
    min-height: 700px;

    .left {
      width: 65%;
      height: 100%;

      .el-card {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      width: 30%;
      height: 100%;

      .el-card {
        width: 100%;
        height: 100%;

        .gbdb {
          width: 320px;
          height: 308px;

          margin: 0 auto;
        }

        .attr-box {
          width: 320px;
          height: 308px;
          background: #f1f1f1;
          border-radius: 4px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
